import { RoutePaths } from '../../libs';

export const videoReviewRoute = (jobId: string): string => `${RoutePaths.videoReview}/${jobId}`;
